import {useEffect, useRef, useState} from 'react'

const useStickyState = () => {
  const sentinelRef = useRef(null)
  const [isSticky, setIsSticky] = useState(false)

  useEffect(() => {
    if (!sentinelRef.current) return

    const observer = new IntersectionObserver(([entry]) => setIsSticky(!entry.isIntersecting), {
      threshold: 0,
      rootMargin: '0px'
    })

    observer.observe(sentinelRef.current)

    return () => observer.disconnect()
  }, [])

  return {sentinelRef, isSticky}
}

export default useStickyState
